function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  d: "M4 11h1a1 1 0 100-2H4V7h1a1 1 0 100-2H4V4c0-1.1.9-2 2-2h10a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2v-1h1a1 1 0 000-2H4z",
  fill: "#a5b3bb"
}), React.createElement("path", {
  d: "M8 12h2v3H8zm3-3h2v6h-2zm3-4h2v10h-2zM2 14a1 1 0 011-1h1v2H3a1 1 0 01-1-1zm0-4a1 1 0 011-1h1v2H3a1 1 0 01-1-1zm0-4a1 1 0 011-1h1v2H3a1 1 0 01-1-1z",
  fill: "#0d2b3e"
}))));